// All gallery imagery below is premium SAMPLE placeholder photography.
// Replace the URLs with photos of real MetalMuse prints when available.
const U = (id, w = 900) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&w=${w}&q=80`;

export const HERO_IMAGE = "https://images.unsplash.com/photo-1691036561573-4b76998b60de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBsaXZpbmclMjByb29tJTIwYXJ0JTIwcHJpbnR8ZW58MHx8fHwxNzg2NTg3MzU0fDA&ixlib=rb-4.1.0&q=85";

export const COMPARISON_IMAGE = "https://images.unsplash.com/photo-1500964757637-c85e8a162699?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85";

export const PRODUCTS = [
  {
    id: "8x10-metal-print",
    name: "8×10 Metal Print",
    price: 35,
    currency: "CAD",
    image: "https://images.unsplash.com/photo-1686644472126-0d71b11d51a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxtZXRhbCUyMHBob3RvJTIwcHJpbnQlMjBmcmFtZWR8ZW58MHx8fHwxNzg2NTg3MzY3fDA&ixlib=rb-4.1.0&q=85",
    description: "Our signature size. A gallery-grade aluminum panel with stunning depth and a glossy, vibrant finish — ready to hang.",
    features: ["Premium aluminum panel", "Ready to hang", "Free photo enhancement"],
  },
  {
    id: "6x8-metal-print",
    name: "6×8 Metal Print",
    price: 25,
    currency: "CAD",
    image: "https://images.unsplash.com/photo-1686644472126-0d71b11d51a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxtZXRhbCUyMHBob3RvJTIwcHJpbnQlMjBmcmFtZWR8ZW58MHx8fHwxNzg2NTg3MzY3fDA&ixlib=rb-4.1.0&q=85",
    description: "Perfect for desks, shelves and smaller walls. The same high-definition sublimation quality in a compact format.",
    features: ["Premium aluminum panel", "Ready to hang", "Free photo enhancement"],
  },
  {
    id: "fridge-magnet",
    name: "Fridge Magnet (10.5 × 7.5 cm)",
    price: 10,
    currency: "CAD",
    image: "https://images.unsplash.com/photo-1684741940718-2f6008ac782f?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    description: "A little piece of memory for your fridge. Durable, vivid and a favourite affordable gift.",
    features: ["Durable metal finish", "Strong magnet backing", "Great gift idea"],
  },
];

export const PRODUCT_OPTIONS = [
  "8×10 Metal Print — $35 CAD",
  "6×8 Metal Print — $25 CAD",
  "Fridge Magnet (10.5 × 7.5 cm) — $10 CAD",
];

export const PRICE_MAP = {
  [PRODUCT_OPTIONS[0]]: 35,
  [PRODUCT_OPTIONS[1]]: 25,
  [PRODUCT_OPTIONS[2]]: 10,
};

export const SAME_DAY_FEE = 5;

export const SERVICES = [
  "Custom Photo Prints",
  "Family Portraits",
  "Wedding Photos",
  "Pet Portraits",
  "Memorial Photos",
  "Anime Metal Posters",
  "Car Photography Prints",
  "Gift Ideas",
];

export const GALLERY_CATEGORIES = ["All", "Family", "Couples", "Pets", "Cars", "Anime", "Memorial", "Landscape"];

export const GALLERY_ITEMS = [
  { src: U("photo-1598887048474-3e0be05bd11f"), category: "Family", title: "Family portrait" },
  { src: U("photo-1511895426328-dc8714191300"), category: "Family", title: "Family moments" },
  { src: "https://images.unsplash.com/photo-1615966650071-855b15f29ad1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxyb21hbnRpYyUyMGNvdXBsZSUyMHN1bnNldHxlbnwwfHx8fDE3ODY1ODczNTR8MA&ixlib=rb-4.1.0&q=85&w=900", category: "Couples", title: "Sunset silhouette" },
  { src: U("photo-1516589178581-6cd7833ae3b2"), category: "Couples", title: "Together" },
  { src: U("photo-1558788353-f76d92427f16"), category: "Pets", title: "Golden retriever" },
  { src: U("photo-1543466835-00a7907e9de1"), category: "Pets", title: "Best friend" },
  { src: "https://images.unsplash.com/photo-1624001010212-f7bfd7cc74cb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxzcG9ydHMlMjBjYXIlMjBzdW5zZXR8ZW58MHx8fHwxNzg2NTg3MzU0fDA&ixlib=rb-4.1.0&q=85&w=900", category: "Cars", title: "Sunset drive" },
  { src: U("photo-1503376780353-7e6692767b70"), category: "Cars", title: "Night racer" },
  { src: "https://images.pexels.com/photos/28122495/pexels-photo-28122495.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", category: "Anime", title: "Neon city" },
  { src: U("photo-1578632767115-351597cf2477"), category: "Anime", title: "Anime wall art" },
  { src: U("photo-1501630834273-4b5604d2ee31"), category: "Memorial", title: "Peaceful sky" },
  { src: U("photo-1419242902214-272b3f66ee7a"), category: "Memorial", title: "Starlit remembrance" },
  { src: U("photo-1500964757637-c85e8a162699"), category: "Landscape", title: "Mountain sunset" },
  { src: U("photo-1441974231531-c6227db76b6e"), category: "Landscape", title: "Forest light" },
];

export const REVIEWS = [
  {
    name: "Sarah M.",
    location: "Saskatoon, SK",
    text: "The colours on metal are unreal. Our wedding photo looks like it's glowing from inside. Everyone who visits asks where we got it.",
    product: "8×10 Metal Print",
  },
  {
    name: "Daniel K.",
    location: "Regina, SK",
    text: "Ordered a memorial print of my father. The team enhanced the old photo beautifully and handled everything with such care.",
    product: "8×10 Metal Print",
  },
  {
    name: "Aisha R.",
    location: "Moose Jaw, SK",
    text: "My anime poster on metal is the centrepiece of my room. Sharp, vibrant, and it feels indestructible. Same-day delivery actually happened.",
    product: "Anime Metal Poster",
  },
  {
    name: "The Petersons",
    location: "Prince Albert, SK",
    text: "We ordered fridge magnets of the grandkids for the whole family. Ten dollars each and they look premium. Perfect gifts.",
    product: "Fridge Magnets",
  },
];

export const FAQS = [
  {
    q: "How do I order a metal print?",
    a: "Send us your photo through Facebook Messenger, Instagram, WhatsApp, or the order form on this website. We confirm the details, enhance your photo for free, print it on premium aluminum, and deliver or have it ready for pickup.",
  },
  {
    q: "What kind of photo do I need?",
    a: "The higher the resolution, the better — but don't worry. Every order includes free professional photo enhancement, and we'll always contact you first if your photo won't print beautifully.",
  },
  {
    q: "Are metal prints really waterproof and durable?",
    a: "Yes. Our high-definition sublimation process infuses the image into a coated aluminum panel. The result is waterproof, fade resistant and scratch resistant — far more durable than canvas or paper.",
  },
  {
    q: "Do the prints come ready to hang?",
    a: "Every metal print arrives ready to hang with mounting included. No frame needed — the metal panel floats elegantly off your wall.",
  },
  {
    q: "How fast is delivery?",
    a: "Same-day delivery is available for +$5 on qualifying orders in our service area. Standard turnaround is 1–3 business days. Pickup is also available for qualifying orders.",
  },
  {
    q: "Can you print anime artwork?",
    a: "Absolutely. Anime metal posters are one of our most popular products. Send us your artwork and we'll make it shine on metal.",
  },
  {
    q: "Do metal prints make good gifts?",
    a: "They're one of the most memorable gifts you can give — weddings, anniversaries, memorials, pet portraits, or fridge magnets for the whole family.",
  },
  {
    q: "What areas do you serve?",
    a: "We're based in Saskatchewan, Canada and serve customers across the province. Message us to confirm delivery options for your area.",
  },
];

export const BENEFITS = [
  { icon: "Droplets", title: "Waterproof", text: "Spills, humidity, kitchens — metal shrugs it all off." },
  { icon: "Sun", title: "Fade Resistant", text: "Colours stay vivid for decades, even in bright rooms." },
  { icon: "ShieldCheck", title: "Scratch Resistant", text: "A tough coated surface that stands up to real life." },
  { icon: "Frame", title: "Ready to Hang", text: "Mounting included. Unbox it, hang it, love it." },
  { icon: "Sparkles", title: "HD Sublimation", text: "High-definition printing with gallery-grade depth." },
  { icon: "Wand2", title: "Free Enhancement", text: "We professionally enhance every photo before printing." },
  { icon: "Truck", title: "Same-Day Delivery", text: "Available for +$5 on qualifying orders." },
  { icon: "MapPin", title: "Local Pickup", text: "Pickup available for qualifying orders in Saskatchewan." },
];

export const STEPS = [
  { title: "Send us your photo", text: "Message us on Messenger, Instagram, WhatsApp, or use the order form. Any photo works — we'll check it first." },
  { title: "We enhance & print", text: "Free professional photo enhancement, then high-definition sublimation onto a premium aluminum panel." },
  { title: "Quality check", text: "Every print is inspected for colour accuracy, finish and mounting before it leaves our studio." },
  { title: "Delivered or pickup", text: "Same-day delivery (+$5) on qualifying orders, or pick up locally. Ready to hang, out of the box." },
];
